export { ProjectResourceLinks } from "./project-resource-links";
